import React from 'react';
import { Box } from '@mui/material';
import Link from 'next/link';

import { URLS } from 'layouts/DrawerLayout/constants';
import styles from 'components/common/TaskCarDetails/taskCarDetails.style';

const InstaTaskSideBarItemVehicle = ({ vehicle }) => {
  return (
    <Box sx={styles.wrapper}>
      {vehicle && (
        <>
          {vehicle?.image && (
            <Box
              sx={{ ...styles.image, backgroundImage: `url(${vehicle.image})` }}
            />
          )}
          <Box>
            {vehicle?.title && (
              <Box sx={styles.vehicleTitle}>{vehicle?.title}</Box>
            )}
            {vehicle.plate && <Box sx={styles.plate}>{vehicle.plate}</Box>}
          </Box>
          {vehicle.properties && (
            <Box sx={styles.chips}>
              {vehicle.properties.map((property) => (
                <Box key={property} sx={styles.chip}>
                  {property}
                </Box>
              ))}
            </Box>
          )}
          {vehicle.skuId && (
            <Box sx={styles.row}>
              <Box sx={styles.rowTitle}>SKU ID</Box>
              <Box sx={styles.rowValue}>{vehicle.skuId}</Box>
            </Box>
          )}
          {vehicle.internalId && (
            <Box sx={styles.rowSpace}>
              <Box sx={styles.row}>
                <Box sx={styles.rowTitle}>Car ID</Box>
                <Box sx={styles.rowValue}>
                  <Link href={`${URLS.fleetVehicles}/${vehicle.id}`}>
                    {vehicle.internalId}
                  </Link>
                </Box>
              </Box>
            </Box>
          )}

          {vehicle.vin && (
            <Box sx={styles.row}>
              <Box sx={styles.rowTitle}>Vin</Box>
              <Box sx={styles.rowValue}>{vehicle.vin}</Box>
            </Box>
          )}

          {vehicle.procurement?.insuranceProvider && (
            <Box sx={styles.row}>
              <Box sx={styles.rowTitle}>Insurance Company for the vehicle:</Box>
              <Box sx={styles.rowValue}>
                {vehicle.procurement?.insuranceProvider}
              </Box>
            </Box>
          )}
          {vehicle.procurement?.vehicleOwnership && (
            <Box sx={styles.row}>
              <Box sx={styles.rowTitle}>Vehicle Ownership</Box>
              <Box sx={styles.rowValue}>
                {vehicle.procurement?.vehicleOwnership}
              </Box>
            </Box>
          )}
          {vehicle.procurement?.financingProvider && (
            <Box sx={styles.row}>
              <Box sx={styles.rowTitle}>Financing Provider</Box>
              <Box sx={styles.rowValue}>
                {vehicle.procurement?.financingProvider}
              </Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default InstaTaskSideBarItemVehicle;
